import { TemperatureOutputWithOutStatus } from './temperature-output-with-out-status.model';


export class TemperatureSelectByIdOutput implements ITemperatureSelectByIdOutput {
    status!: number;
    message!: string;
    data!: TemperatureOutputWithOutStatus;

    constructor(data?: ITemperatureSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? TemperatureOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemperatureSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITemperatureSelectByIdOutput {
    status: number;
    message: string;
    data: TemperatureOutputWithOutStatus;
}

